"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataSelectorId = exports.DEFAULT_TEXTS = exports.MIN_WIDTH_DATETIME_INPUT = void 0;
const helpers_1 = require("../../../helpers");
exports.MIN_WIDTH_DATETIME_INPUT = helpers_1.FIELD_XXS;
exports.DEFAULT_TEXTS = {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    shortJanuary: 'Jan',
    shortFebruary: 'Feb',
    shortMarch: 'Mar',
    shortApril: 'Apr',
    shortMay: 'May',
    shortJune: 'Jun',
    shortJuly: 'Jul',
    shortAugust: 'Aug',
    shortSeptember: 'Sep',
    shortOctober: 'Oct',
    shortNovember: 'Nov',
    shortDecember: 'Dec',
    shortSunday: 'Su',
    shortMonday: 'Mo',
    shortTuesday: 'Tu',
    shortWednesday: 'We',
    shortThursday: 'Th',
    shortFriday: 'Fr',
    shortSaturday: 'Sa',
    hours: 'Hours:',
    minutes: 'Minutes:',
    seconds: 'Seconds:',
    am: 'AM',
    pm: 'PM',
    monthYearSelectorHeader: 'Select month and year:',
    today: 'Today',
    apply: 'Apply',
    cancel: 'Cancel',
    applyMonth: 'OK',
    cancelMonth: 'Cancel',
    errorDateRequiredText: 'Please select a date.',
    errorHoursRequiredText: 'Please select hours',
    errorMinutesRequiredText: 'Please select minutes',
    errorSecondsRequiredText: 'Please select seconds'
};
exports.dataSelectorId = {
    dateTimeCalendarControl: 'datetime-calendar-control',
    dateTimeSelector: 'datetime-selector',
    timeSelectorWrapper: 'timeselector-wrapper',
    todayControl: 'datetime-today-control',
    monthSelector: 'month-selector',
    applyControl: 'apply-control',
    cancelControl: 'cancel-control',
    applyMonthControl: 'apply-month-control',
    cancelMonthControl: 'cancel-month-control'
};
//# sourceMappingURL=constants.js.map